let language = {
    PHOTO_LIB_LIST_DELET_TITLE: "删除稀有卡库",
    PHOTO_LIB_LIST_DELET_CONTENT: "您确定要删除稀有卡库吗？ 删除稀有卡库将重置随机抽牌规则。 ",
    PHOTO_LIB_LIST_DELET_ISSUE_TITLE: "删除稀有卡库失败",
    PHOTO_LIB_LIST_DELET_ISSUE_CONTENT: "哦! 稀有卡库无法删除，请稍后重试",

}
export { language }